export enum DataSource {
	POS = 1,
	COMMANDCENTER = 2,
	MYFOCUS = 3,
	INTEGRATOR = 4,
}
